import React, { useState } from "react";
import { connect } from "react-redux";
import styles from "./AddSiteModal.module.scss";
import Modal from "components/Modal/Modal";
import FormElement from "components/FormElement/FormElement";
// import Select from "components/Select/Select";
import Button from "components/Button/Button";
import {
    createSiteAction,
} from "store/actions/Actions";

const AddSiteModal = props => {
    const [formData, setFormData] = useState({
		name: "",
		address_1: "",
		address_2: "",
		city: "",
		region: "",
		postal_code: "",
		country_code: 235,
		active: true
    });

    const [stateErrors, setStateErrors] = useState({
        name: "",
    });

    const handleChange = (e) => {
        e.persist();
        setFormData((s) => ({ ...s, name: (e.target && e.target.value) ? e.target.value : '' }));
    };

    const { createSiteAction } = props;

    const addModal = (e) => {
        if (formData.name !== "") {
            createSiteAction(formData);
            props.setShowModal(false);   
            return false;   
        } else {
            setStateErrors((s) => ({
                ...s,
                name: "Site name is required",
            }));
            return false;
        }
    }

    return (
        <Modal className={styles.modal} setShowModal={props.setShowModal}>
            <p className={styles["modal-heading"]}>Create new site</p>

            <div className={styles["modal-content"]}>
                <FormElement labelText="SITE" htmlFor="name" errorMessage={stateErrors.name}>
                    <input
                        placeholder="Site Name"
                        name="name"
                        type="text"
                        maxLength="70"
                        value={formData.name}
                        onChange={handleChange}
                    />
                </FormElement>
            </div>

            <div className={styles["modal-footer"]}>
                <Button
                    text="CANCEL"
                    color="secondary"
                    onClick={() => props.setShowModal(false)}
                />
                <Button
                    text="CREATE"
                    className={styles.create}
                    onClick={(e) => addModal(e)}
                />
            </div>
        </Modal>
    );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    createSiteAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddSiteModal);
